require('../core');

angular.module('ui-ng-notification')
  .controller('phxNotificationMessageController', function ($scope, $timeout, $sce) {

    $scope.dismissTimeout;

    $scope.message.trustedContent = $sce.trustAsHtml($scope.message.content);

    $scope.$watch('message.count', function () {
      $scope.startTimeout();
    });

    $scope.shouldShowMessageCount = function shouldShowMessageCount() {
      return $scope.message.count > 1;
    }

    $scope.cancelTimeout = function () {
      $timeout.cancel($scope.dismissTimeout);
    };

    $scope.startTimeout = function () {
      if ($scope.message.dismissOnTimeout) {

        $scope.cancelTimeout();
        $scope.dismissTimeout = $timeout(function () {
          $scope.dismiss($scope.message.id);
        }, $scope.message.timeout);

        if ($scope.combineDuplications) {
          $scope.message.timeout += 500;
        }
      }
    };

    $scope.onMouseEnter = function () {
      $scope.cancelTimeout();
    };

    $scope.onMouseLeave = function () {
      $scope.startTimeout();
    };

    $scope.$on('$destroy', function () {
      $scope.cancelTimeout();
    });

  })
  .directive('phxNotificationMessage', function () {
    return {
      scope: false,
      restrict: 'EA',
      replace: false,
      requires: '^phxNotification',
      controller: 'phxNotificationMessageController',
      templateUrl: function (element, attrs) {
        return 'ui-ng-notification/dist/templates/' + (attrs.type || 'standard') + '_message.html';
      },
      link: function (scope, element, attrs, ctrl, transclude) {

        element.attr('data-message-id', scope.message.id);
        scope.startTimeout();

        element.on('click keyup', function (event) {
          if (event.type === 'click' || (event.type === 'keyup' && (event.which === 13 || event.which === 32))) {
            scope.$applyAsync(function () {
              scope.dismiss(scope.message.id);
            });
          }
        });

        scope.$on('$destroy', function () {
          element.off('click keyup');
        });

      }
    };
  });



// WEBPACK FOOTER //
// notification_message.js